import styles from "./Todo.module.css";
function Version()
{
 return  <h5 className={styles.headline}>Version 1.2</h5>
}

export default Version;